<template>
  <div>
    <el-form :inline="true" ref="searchForm" :model="searchForm" class="forTbFilter" @submit.native.prevent>
      <el-form-item label="套餐系列：">
        <el-input v-model.trim="searchForm.name" placeholder="支持模糊搜索" clearable></el-input>
      </el-form-item>

      <el-form-item label="商品名称：">
        <el-input v-model.trim="searchForm.shareName" placeholder="支持模糊搜索商品" clearable></el-input>
      </el-form-item>

      <el-form-item label="商品设置：">
        <el-select v-model="searchForm.isHavePkg" clearable>
          <el-option label="未设置" value="0"></el-option>
          <el-option label="已设置" value="1"></el-option>
        </el-select>
      </el-form-item>


      <el-form-item label="套餐类型：">
        <el-select v-model="searchForm.isVoice" clearable>
          <el-option v-for="item in isVoiceOption" :value="item.code" :key="item.description"
            :label="item.description"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="跨月类型：">
        <el-select v-model="searchForm.isNextMonth" clearable>
          <el-option label="跨月" value="1"></el-option>
          <el-option label="自然月" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="余额限制：">
        <el-select v-model="searchForm.type" clearable>
          <el-option label="不限制" value="0"></el-option>
          <el-option label="限制余额" value="1"></el-option>
          <el-option label="限制余额并且开户预存" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="btnArea">
        <el-button type="primary" plain icon="el-icon-search" @click="getPkgGroupListPageHandle">搜索</el-button>
        <el-button type="success" plain icon="el-icon-plus" @click="showAddPkgGroup">新建系列</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tbpg.tableData" border fit highlight-current-row style="width: 100%"
      :header-cell-style="{ background: '#f5f5f5' }">
      <el-table-column prop="name" label="系列名称" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="nameRemark" label="系列备注" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="typeName" label="余额限制" align="center" show-overflow-tooltip></el-table-column>
      <!-- <el-table-column prop="yucunName" label="二次活动" align="center" show-overflow-tooltip></el-table-column> -->
      <!-- <el-table-column prop="remark" label="微信弹窗" align="center" show-overflow-tooltip></el-table-column>  -->
      <el-table-column prop="saleName" label="活动名称" align="center"></el-table-column>
      <!-- <el-table-column prop="isAuthName" label="实名限制" align="center" show-overflow-tooltip></el-table-column> -->
      <!-- <el-table-column prop="limitName" label="限速设置" align="center" show-overflow-tooltip></el-table-column> -->
      <el-table-column prop="createTime" label="创建时间" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="stateName" label="状态" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="440">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="showEditPkgGroup(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="showImg(scope.row)">弹窗配置</el-button>

          <el-button type="text" size="small" @click="sharePkgGroup(scope.row)">商城配置</el-button>
          <el-button type="text" size="small" @click="sharePkgGroup1(scope.row)">活动配置</el-button>
          <el-button type="text" size="small" @click="sharePkgGroup11(scope.row)">商户号</el-button>
          <el-button type="text" size="small" @click="autoChangeGroup(scope.row)">转移系列</el-button>

          <el-button type="text" size="small" @click="deleteGroupId(scope.row.id)">删除系列</el-button>
          <el-button type="text" size="small" @click="changeStateHandle(scope.row.id)">
            <span style="color: red">
              {{ showbtnText(scope.row.state) }}
            </span>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="tbpg.currentPage"
      :page-sizes="[15, 50, 100, 500]" :page-size="tbpg.pageSize" background
      layout="total, sizes, prev, pager, next, jumper" :total="tbpg.total">
    </el-pagination>
    <el-dialog :append-to-body="true" :title="title" :visible.sync="addGroupVisibale" width="600px" @close="cancel"
      :close-on-click-modal="false">
      <el-form ref="addOrEditGroupForm" :model="addOrEditGroupForm" :rules="addOrEditGroupRules" label-width="120px">
        <el-form-item label="套餐组名称：" prop="name">
          <el-input v-model.trim="addOrEditGroupForm.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="套餐备注：" prop="nameRemark">
          <el-input v-model.trim="addOrEditGroupForm.nameRemark" clearable></el-input>
        </el-form-item>
        <el-form-item label="余额限制：" prop="type">
          <el-select v-model="addOrEditGroupForm.type" placeholder="请选择">
            <el-option v-for="item in isPriceOption" :value="item.code" :key="item.description"
              :label="item.description"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="余额购买参数：" prop="priceData">
          <el-input v-model.trim="addOrEditGroupForm.priceData" placeholder="严谨按照参数规范填写 参数示列请点击下方按钮" clearable></el-input>
        </el-form-item>
        <el-form-item label="是否跨月：" prop="isNextMonth">
          <el-select v-model="addOrEditGroupForm.isNextMonth" placeholder="请选择">
            <el-option v-for="item in isMonthOption" :value="item.code" :key="item.description"
              :label="item.description"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="活动类型：" prop="isPrice">
          <el-select v-model="addOrEditGroupForm.isSale" placeholder="请选择">
            <el-option v-for="item in isPriceOptions" :value="item.code" :key="item.description"
              :label="item.description"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二次活动：" prop="yucun">
          <el-select v-model="addOrEditGroupForm.yucun" placeholder="请选择">
            <el-option v-for="item in isYucunOption" :value="item.code" :key="item.description"
              :label="item.description"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="秒反设置：" prop="isMiao">
          <el-select v-model="addOrEditGroupForm.isMiao" placeholder="请选择">
            <el-option v-for="item in isMiaoList" :value="item.code" :key="item.description"
              :label="item.description"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="addOrEditGroupForm.isMiao == 1" label="秒反金额/元：" prop="miaoPrice">
          <el-input v-model.trim="addOrEditGroupForm.miaoPrice" placeholder="请输入你要秒反得金额" clearable></el-input>
        </el-form-item>
        <el-form-item label="套餐类型：" prop="isNextMonth">
          <el-select v-model="addOrEditGroupForm.isVoice" placeholder="请选择">
            <el-option v-for="item in isVoiceOption" :value="item.code" :key="item.description"
              :label="item.description"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="实名跳转：" prop="poolName">
          <el-input v-model.trim="addOrEditGroupForm.poolName" placeholder="控制实名跳转，电信卡请填 电信 ，联通卡 填联通。特殊实名链接 请直接填链接"
            clearable></el-input>
        </el-form-item>
        <el-form-item label="微信弹窗内容：" prop="remark">
          <el-input v-model.trim="addOrEditGroupForm.remark" placeholder="将会在微信套餐页面进行弹窗提示" clearable></el-input>
        </el-form-item>
        <el-form-item label="自动续费：" prop="">
          <el-radio-group v-model="addOrEditGroupForm.isDown">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="实名限制：" prop="isAuth">
          <el-radio-group v-model="addOrEditGroupForm.isAuth">
            <el-radio :label="1">无限制</el-radio>
            <el-radio :label="0">先套餐后实名</el-radio>
            <el-radio :label="2">先实名后套餐</el-radio>
          </el-radio-group>
        </el-form-item>


        <el-form-item label="绑定手机号：" prop="bindPhone">
          <el-radio-group v-model="addOrEditGroupForm.bindPhone">
            <el-radio :label="0">无需绑定</el-radio>
            <el-radio :label="1">先套餐后绑定</el-radio>
            <el-radio :label="2">先绑定后套餐</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="绑定页面：" prop="newBind">
          <el-radio-group v-model="addOrEditGroupForm.newBind">
            <el-radio :label="1">假实名</el-radio>
            <el-radio :label="0">普遍绑定</el-radio>
          </el-radio-group>
        </el-form-item>


        <el-form-item label="限速规则：">
          <el-select v-model="addOrEditGroupForm.limitId" clearable filterable>
            <el-option v-for="item in branchSupplierOption" :value="item.code" :key="item.code"
              :label="item.description"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客服链接：" prop="kefuUrl">
          <el-input v-model.trim="addOrEditGroupForm.kefuUrl" clearable></el-input>
        </el-form-item>
        <el-form-item label="提前停机天数：" prop="stopDay">
          <el-input v-model.trim="addOrEditGroupForm.stopDay" placeholder="在套餐有效期低于设置的天数时，将进行停机操作（选填）。"
            clearable></el-input>
        </el-form-item>

        <el-form-item label="达量停机：" prop="stopData">
          <el-input v-model.trim="addOrEditGroupForm.stopData" placeholder="当月使用量达到多少/GB时，进行停机。次月恢复" clearable></el-input>
        </el-form-item>




      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" @click="showYue">查询余额参数示列</el-button>
        <el-button @click="cancel">取 消</el-button>
        <el-button type="success" plain icon="el-icon-plus" @click="addOrEidtGroupHandle">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :append-to-body="true" title="余额参数示列" :visible.sync="shareImgs" width="700px" @close="cancel1"
      :close-on-click-modal="false">
      <div style="text-align: center; padding: 10px 0; color: #f56c6c">
        注：最多只支持6个参数，amount代表充值金额/元
        giftBalance表示赠送金额/元。请修改后完整输入此参数
      </div>
      <div style="text-align: center; width: 100%">
        <p alt="" style="margin: 0 auto">{{ urls }}</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="copy()" class="copy_url" :data-clipboard-text="urls">复制参数</el-button>
      </div>
    </el-dialog>

    <el-dialog :append-to-body="true" class="formDialog" :title="title" :visible.sync="shareGroup" width="600px"
      @close="cancel12" :close-on-click-modal="false">
      <el-form ref="shareForm" :model="shareForm" label-width="120px">
        <el-form-item label="商品图(建议像素512*512)：">
          <input type="file" ref="file1" placeholder="必选" />
          <img :src="getImgUrl() + shareForm.shareImg" alt="" width="150" height="150" />
        </el-form-item>


        <el-form-item label="介绍图一：">
          <input type="file" ref="file3" placeholder="选填" />
          <img :src="getImgUrl() + shareForm.shareImg1" alt="" width="150" height="150" />
        </el-form-item>

        <el-form-item label="介绍图二：">
          <input type="file" ref="file4" placeholder="选填" />
          <img :src="getImgUrl() + shareForm.shareImg2" alt="" width="150" height="150" />
        </el-form-item>

        <el-form-item label="介绍图三：">
          <input type="file" ref="file5" placeholder="选填" />
          <img :src="getImgUrl() + shareForm.shareImg3" alt="" width="150" height="150" />
        </el-form-item>

        <el-form-item label="商品标题:" prop="shareName">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.shareName" placeholder="必选" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="商品分类:" prop="shareType">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.shareType" placeholder="必选" clearable></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="商品价格/元:" prop="sharePrice">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.sharePrice" placeholder="必选" clearable></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="分代理商佣金/元:" prop="shareYongjing">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.shareYongjing" clearable></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="上下架状态：" prop="isShare">
          <el-radio-group v-model="shareForm.isShare">
            <el-radio :label="0">下架</el-radio>
            <el-radio :label="1">上架</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="可见状态状态：" prop="showType">
          <el-radio-group v-model="shareForm.showType">
            <el-radio :label="0">全部可见</el-radio>
            <el-radio :label="1">代理不可见</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="分类排序:" prop="shareTypeOrderBy">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.shareTypeOrderBy" placeholder="排序（数字越大排序越靠前）" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="商品排序:" prop="shareShopOrderBY">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.shareShopOrderBY" placeholder="排序（数字越大排序越靠前）" clearable></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel12">取 消</el-button>
        <el-button type="primary" @click="addOrEidtPkgHandle">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :append-to-body="true" class="formDialog" :title="title" :visible.sync="shareGroup11" width="600px"
      @close="cancel12" :close-on-click-modal="false">
      <el-form ref="shareForm" :model="shareForm" label-width="120px">
        <el-form-item label="微信商户号:" prop="subId">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.subId" placeholder="商户号须和公众号进行绑定" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="微信商户密钥:" prop="subKey">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.subKey" placeholder="必选" clearable></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel12">取 消</el-button>
        <el-button type="primary" @click="addOrEidtPkgHandle11">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog :append-to-body="true" class="formDialog" :title="title" :visible.sync="shareGroup1" width="600px"
      @close="cancel12" :close-on-click-modal="false">
      <el-form ref="shareForm" :model="shareForm" label-width="120px">
        <el-form-item label="活动图(建议像素750*1392)：">
          <input type="file" ref="file2" placeholder="必选">
          <img :src="getImgUrl() + shareForm.priceImgUrl" alt="" width="150" height="150">
        </el-form-item>

        <el-form-item label="购买券价格:" prop="salePrice">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.salePrice" placeholder="必选" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="券面值/元:" prop="saleQuanPrice">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.saleQuanPrice" placeholder="必选" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="券个数:" prop="saleQuanSize">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.saleQuanSize" placeholder="必选" clearable></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="次券面值/元:" prop="saleQuanPriceTwo">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.saleQuanPriceTwo" placeholder="选填-可赠送不同面额的券" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="次券个数:" prop="saleQuanSizeTwo">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.saleQuanSizeTwo" placeholder="选填-可赠送不同面额的券" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="卷过期时间:" prop="saleDay">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.saleDay" placeholder="必选-多少天后过期" clearable></el-input>
          </el-col>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel12">取 消</el-button>
        <el-button type="primary" @click="addOrEidtPkgHandle1">确 定</el-button>
      </div>
    </el-dialog>




    <el-dialog :append-to-body="true" class="formDialog" :title="title" :visible.sync="yueDataFlg" width="600px"
      @close="cancel12" :close-on-click-modal="false">
      <el-form ref="yueData" :model="yueData" label-width="120px">
        <p style="color:red">仅仅支持自运营流量池的卡。套餐使用完后或者过期后 可用余额自动购买绑定的套餐</p>
        <el-form-item label="续费类型：" prop="subType">
          <el-radio-group v-model="yueData.sysType">
            <el-radio label="0">套餐超套配置</el-radio>
            <el-radio label="1">套餐续期配置</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="套餐编码:" prop="yuPkgDataId" v-if="yueData.sysType == 0">
          <el-col :span="22">
            <el-input v-model.trim="yueData.yuPkgDataId" placeholder="不填则不自动续费" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="续费类型：" prop="yuType" v-if="yueData.sysType == 1">
          <el-radio-group v-model="yueData.yuType">
            <el-radio :label="0">暂不配置过期续费</el-radio>
            <el-radio :label="1">自动续延订购的最大主套餐</el-radio>
            <el-radio :label="2">自定义续延套餐编码</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="套餐编码:" prop="yuPkgOutId" v-if="yueData.sysType == 1 && yueData.yuType == 2">
          <el-col :span="22">
            <el-input v-model.trim="yueData.yuPkgOutId" placeholder="套餐到期前1天，自动使用余额订购此套餐" clearable></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel12">取 消</el-button>
        <el-button type="primary" @click="sureYuDataMthed()">确 定</el-button>
      </div>
    </el-dialog>



    <el-dialog :append-to-body="true" class="formDialog" title="弹窗配置" :visible.sync="showImgFlg" width="600px"
      @close="cacelImg" :close-on-click-modal="false">
      <el-form ref="showImgData" :model="showImgData" label-width="120px">
        <el-form-item label="弹窗配置：" prop="isTitle">
          <el-radio-group v-model="showImgData.isTitle">
            <el-radio :label="0">不弹窗</el-radio>
            <el-radio :label="1">弹窗</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="弹窗图：">
          <input type="file" ref="file6" placeholder="">
          <img :src="getImgUrl() + showImgData.titleImg" alt="" width="300" height="100">
        </el-form-item>

        <el-form-item label="点击跳转链接:" prop="titleUrl">
          <el-col :span="22">
            <el-input v-model.trim="showImgData.titleUrl" placeholder="填 套餐/余额 即可跳转指定页面，其它填第三方跳转链接" clearable></el-input>
          </el-col>
        </el-form-item>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cacelImg()">取 消</el-button>
        <el-button type="primary" @click="sureImg">确 定</el-button>
      </div>
    </el-dialog>






    <el-dialog :append-to-body="true" class="formDialog" title="自动迁移系列" :visible.sync="changeFlg" width="600px"
      @close="changeCancel" :close-on-click-modal="false">
      <el-form ref="changeData" :model="changeData" label-width="120px">
        <p style="color:red">此配置是卡激活多少天后，自动迁移套餐系列。 一般用于前期低价套餐 自动 转移高价套餐系列</p>
        <el-form-item label="新系列名称：">
          <el-select v-model="changeData.changeId" clearable filterable>
            <el-option v-for="item in pkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="激活天数:" prop="changeDay">
          <el-col>
            <el-input v-model.trim="changeData.changeDay" placeholder="当大于0时，才会自动生效" clearable></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="changeCancel">取 消</el-button>
        <el-button type="primary" @click="changeSure()">确 定</el-button>
      </div>
    </el-dialog>




  </div>
</template>
<script>
import {
  getPkgGroupListPage,
  addPkgGroup,
  updatePkgGroup,
  changePkgGroupState,
  getPkgIsMonthOption,
} from "@/api/package.js";
import common from "@/utils/common.js";
import Clipboard from "clipboard";
export default {
  data() {
    return {
      yueDataFlg: false,
      yueData: {
        sysType: '0', //0表示套餐用完设置  1 表示过期设置
        id: '',
        yuType: '',
        yuPkgDataId: '',
        yuPkgOutId: ''
      },
      existBackImg: false,
      shareGroup: false,
      existBackImg1: false,
      shareGroup1: false,
      shareGroup11: false,
      shareForm: {
        id: "",
        name: "",
        subId: "",
        subKey: "",


        shareType: '',
        shareYongjing: '',
        sharePrice: '',
        shareTypeOrderBy: '',
        shareShopOrderBY: '',

        shareName: "",
        shareImg: "",
        priceImgUrl: "",
        isShare: "",
        showType: '',


        salePrice: '',
        saleQuanPrice: '',
        saleQuanSize: '',
        saleQuanPriceTwo: '',
        saleQuanSizeTwo: '',
        saleDay: '',

        shopImg1: '',
        shopImg2: '',
        shopImg3: '',

      },
      branchSupplierOption: [],
      isShareOptions: [
        {
          code: 0,
          description: "禁用",
        },
        {
          code: 1,
          description: "启用",
        },
      ],
      urls: "",
      shareImgs: false,
      searchForm: {
        name: "",
        isVoice: "",
        isNextMonth: "",
      },
      tbpg: {
        tableData: [],
        currentPage: 1,
        pageSize: 15,
        total: 0,
      },
      isPriceOptions: [
        {
          code: 0,
          description: "无活动",
        },
        {
          code: 1,
          description: "购买优惠券活动",
        }

      ],
      isMiaoList: [
        {
          code: 0,
          description: "不秒反",
        },
        {
          code: 1,
          description: "一次性秒反",
        },
      ],
      addOrEditGroupForm: {
        changeId: "",
        changeDay: "",

        name: "",
        type: "",
        isMiao: "",
        yucun: "0",
        subId: "",
        subKey: "",
        miaoPrice: "",
        kefuUrl: "",
        priceImgUrl: "",
        isSale: "",
        isAuth: "",
        isNextMonth: "",
        limitId: "",
        supplierType: "1",
        remark: "",
        isDown: "",
        priceData: "",
        poolName: "",
        isVoice: "",
        firstPrice: '',
        stopData: "",

        shareType: '',
        shareYongjing: '',
        sharePrice: '',
        shareTypeOrderBy: '',
        shareShopOrderBY: '',
        stopDay: '',
        nameRemark: '',

        shopImg1: '',
        shopImg2: '',
        shopImg3: '',
        titleImg: '',
        titleUrl: '',
        isTitle: '',
        bindPhone: '',
        newBind: ''

      },
      isPriceOption: [
        {
          code: 0,
          description: "不限制",
        },
        {
          code: 1,
          description: "限制余额",
        },
        {
          code: 2,
          description: "限制余额并且开户预存",
        },
      ],
      isVoiceOption: [
        {
          code: 0,
          description: "流量",
        },
        {
          code: 1,
          description: "流量+语音",
        },
      ],

      isYucunOption: [
        {
          code: 0,
          description: "无二次活动",
        },
        {
          code: 1,
          description: "预存送免金券-29元券",
        },
        {
          code: 3,
          description: "购买叠加券活动",
        },
      ],
      currentId: "",
      addFlag: null,
      addGroupVisibale: false,
      title: "",
      pkgTypeOption: [],
      supplierOption: [],
      isMonthOption: [],
      addOrEditGroupRules: {
        name: [{ required: true, message: "请输入套餐名称", trigger: "blur" }],
        type: [
          { required: true, message: "请选择套餐名称", trigger: "change" },
        ],
        isNextMonth: [
          { required: true, message: "请选择套餐名称", trigger: "change" },
        ],
        supplierType: [
          { required: true, message: "请选择套餐名称", trigger: "change" },
        ],
      },

      showImgFlg: false,
      showImgData: {
        id: '',
        titleImg: '',
        titleUrl: '',
        isTitle: ''
      },
      pkgGroup:[],

      changeFlg: false,
      changeData: {
        id: '',
        changeId: '',
        changeDay: ''
      },

    };
  },
  methods: {

    autoChangeGroup(row) {
      common.getPkgGroupListCom(this, 'pkgGroup');
      this.changeData.changeDay = row.changeDay;
      this.changeData.id = row.id;
      this.changeData.changeId = row.changeId
      this.changeFlg = true;
    },
    changeCancel() {
      this.changeFlg = false;
    },
    changeSure() {
      common
        .sysRequest("pkg/group/auto/changeGroup", this.changeData, "post")
        .then((res) => {
          if (res.data.code == 200) {
            this.getPkgGroupListPageHandle();
            this.$message.success(res.data.message);
            this.changeFlg = false;
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));
    },



    showImg(row) {
      this.showImgData.id = row.id;
      this.showImgData.titleUrl = row.titleUrl;
      this.showImgData.titleImg = row.titleImg;
      this.showImgData.isTitle = row.isTitle;
      this.showImgFlg = true;
    },
    cacelImg() {
      this.showImgFlg = false;
    },
    sureImg() {
      let fd = new FormData();
      Object.keys(this.showImgData).forEach((key) => {
        fd.append(key, this.showImgData[key]);
      });
      fd.append("title4", this.$refs.file6.files[0]);
      common
        .sysRequest("pkg/group/update/title", fd, "post")
        .then((res) => {
          if (res.data.code == 200) {
            this.$refs.file6.value = "";
            this.getPkgGroupListPageHandle();
            this.$message.success(res.data.message);
            callback(res);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));

      var _this = this;
      function callback(res) {
        if (res.data.code == 200) {
          _this.showImgFlg = false;
        } else {
          _this.$message.error(res.data.message);
        }
      }
    },


    deleteGroupId(id) {

      this.$confirm("此操作会把套餐系列和系列下面的套餐全部删除。确定要操作吗？", "提示", {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        var data = { id: id }
        common.sysRequest("pkg/group/delete/group", data, "post").then((res) => {
          if (res.data.code == 200) {
            this.getPkgGroupListPageHandle();
            this.$message.success(res.data.message);
          } else {
            this.$message.error(res.data.message);
          }
        })
          .catch((err) => console.error(err));

      })

    },


    sureYuDataMthed() {
      common
        .sysRequest("pkg/group/update/yue/config", this.yueData, "post")
        .then((res) => {
          if (res.data.code == 200) {
            this.getPkgGroupListPageHandle();
            this.$message.success(res.data.message);
            this.yueDataFlg = false;
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));
    },
    yuDataOpen(row) {
      this.yueData.id = row.id;
      this.yueData.yuPkgDataId = row.yuPkgDataId;
      this.yueData.yuPkgOutId = row.yuPkgOutId;
      this.yueData.yuType = row.yuType;
      this.yueDataFlg = true;
    },



    sharePkgGroup11(row) {
      this.shareForm.id = row.id;
      this.shareForm.subId = row.subId;
      this.shareForm.subKey = row.subKey;
      this.shareForm.shareName = row.shareName;

      this.shareGroup11 = true;
    },

    sharePkgGroup(row) {
      this.shareForm.id = row.id;
      this.shareForm.shareImg1 = row.shopImg1;
      this.shareForm.shareImg2 = row.shopImg2;
      this.shareForm.shareImg3 = row.shopImg3;

      this.shareForm.shareName = row.shareName;
      this.shareForm.shareImg = row.shareImg;
      this.shareForm.isShare = row.isShare;
      this.shareForm.showType = row.showType;
      this.shareForm.shareType = row.shareType;
      this.shareForm.sharePrice = row.sharePrice;
      this.shareForm.shareYongjing = row.shareYongjing;
      this.shareForm.shareTypeOrderBy = row.shareTypeOrderBy;
      this.shareForm.shareShopOrderBY = row.shareShopOrderBY;
      this.existBackImg = true;
      this.shareGroup = true;
    },

    sharePkgGroup1(row) {
      this.shareForm.id = row.id;
      this.shareForm.shareName = row.shareName;
      this.shareForm.priceImgUrl = row.priceImgUrl;
      this.shareForm.salePrice = row.salePrice;
      this.shareForm.saleQuanPrice = row.saleQuanPrice;
      this.shareForm.saleQuanSize = row.saleQuanSize;
      this.shareForm.saleQuanPriceTwo = row.saleQuanPriceTwo;
      this.shareForm.saleQuanSizeTwo = row.saleQuanSizeTwo;
      this.shareForm.saleDay = row.saleDay;
      this.existBackImg1 = true;
      this.shareGroup1 = true;
    },
    cancel12() {
      this.yueDataFlg = false;
      this.shareGroup = false;
      this.existBackImg1 = false;
      this.shareGroup1 = false;
      this.shareGroup11 = false;
      this.$refs.shareForm.resetFields();
    },
    addOrEidtPkgHandle() {
      let fd = new FormData();
      Object.keys(this.shareForm).forEach((key) => {
        fd.append(key, this.shareForm[key]);
      });
      fd.append("title", this.$refs.file1.files[0]);

      fd.append("title1", this.$refs.file3.files[0]);
      fd.append("title2", this.$refs.file4.files[0]);
      fd.append("title3", this.$refs.file5.files[0]);

      common
        .sysRequest("pkg/group/insert/share", fd, "post")
        .then((res) => {
          if (res.data.code == 200) {
            this.$refs.file1.value = "";
            this.$refs.file3.value = "";
            this.$refs.file4.value = "";
            this.$refs.file5.value = "";
            this.getPkgGroupListPageHandle();
            this.$message.success(res.data.message);
            callback(res);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));

      var _this = this;
      function callback(res) {
        if (res.data.code == 200) {
          _this.shareGroup = false;
        } else {
          _this.$message.error(res.data.message);
        }
      }
    },
    addOrEidtPkgHandle1() {
      let fd = new FormData();
      Object.keys(this.shareForm).forEach((key) => {
        fd.append(key, this.shareForm[key]);
      });
      fd.append("title", this.$refs.file2.files[0]);

      common
        .sysRequest("pkg/group/insert/price/img", fd, "post")
        .then((res) => {
          if (res.data.code == 200) {
            this.$refs.file2.value = "";
            this.getPkgGroupListPageHandle();
            this.$message.success(res.data.message);
            callback(res);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));

      var _this = this;
      function callback(res) {
        if (res.data.code == 200) {
          _this.shareGroup1 = false;
        } else {
          _this.$message.error(res.data.message);
        }
      }
    },

    addOrEidtPkgHandle11() {
      var data = {
        id: this.shareForm.id,
        subId: this.shareForm.subId,
        subKey: this.shareForm.subKey,
      };
      common
        .sysRequest("pkg/group/insert/wx/config", data, "post")
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success(res.data.message);
            this.shareGroup11 = false;
            this.getPkgGroupListPageHandle();
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));
    },
    //复制功能
    copy() {
      var clipboard = new Clipboard(".copy_url");
      clipboard.on("success", (e) => {
        this.$message.success("复制成功");
        this.shareImgs = false;
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$message.success("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    showYue() {
      this.urls =
        '[{"amount":25,"giftBalance":0},{"amount":35,"giftBalance":0.5},{"amount":50,"giftBalance":1},{"amount":100,"giftBalance":2},{"amount":200,"giftBalance":5},{"amount":500,"giftBalance":20}]';
      this.shareImgs = true;
    },
    cancel() {
      this.shareImgs = false;
      this.addGroupVisibale = false;
      this.$refs.addOrEditGroupForm.resetFields();
    },
    cancel1() {
      this.shareImgs = false;
    },
    showbtnText(state) {
      return common.showTxtByState(state, { 0: "启用", 1: "禁用" });
    },
    getPkgGroupListPageHandle($event) {
      common.resetCurrentPage(this, $event, "tbpg");
      var data = common.getRequestParams(this, "tbpg", this.searchForm);
      getPkgGroupListPage(data).then((res) => {
        common.listCallback(this, res, "tbpg");
      });
    },
    showAddPkgGroup() {
      this.addGroupVisibale = true;
      this.addFlag = true;
      this.title = "新增套餐组";
      this.addOrEditGroupForm = this.$data.addOrEditGroupForm;
    },
    showEditPkgGroup(row) {
      this.addGroupVisibale = true;
      this.addFlag = false;
      this.title = "修改套餐组";
      this.addOrEditGroupForm.changeDay = row.changeDay;
      this.addOrEditGroupForm.changeId = row.changeId;

      this.addOrEditGroupForm.newBind = row.newBind;
      this.addOrEditGroupForm.stopData = row.stopData;
      this.addOrEditGroupForm.bindPhone = row.bindPhone;
      this.addOrEditGroupForm.nameRemark = row.nameRemark;
      this.addOrEditGroupForm.shareType = row.shareType;
      this.addOrEditGroupForm.firstPrice = row.firstPrice;
      this.addOrEditGroupForm.shareYongjing = row.shareYongjing;
      this.addOrEditGroupForm.sharePrice = row.sharePrice;
      this.addOrEditGroupForm.shareTypeOrderBy = row.shareTypeOrderBy;
      this.addOrEditGroupForm.shareShopOrderBY = row.shareShopOrderBY;
      this.addOrEditGroupForm.yucun = row.yucun;
      this.addOrEditGroupForm.limitId = row.limitId;
      this.addOrEditGroupForm.isAuth = row.isAuth;
      this.addOrEditGroupForm.kefuUrl = row.kefuUrl;
      this.addOrEditGroupForm.priceImgUrl = row.priceImgUrl;
      this.addOrEditGroupForm.name = row.name;
      this.addOrEditGroupForm.xuliangId = row.xuliangId;
      this.addOrEditGroupForm.type = row.type;
      this.addOrEditGroupForm.isVoice = row.isVoice;
      this.addOrEditGroupForm.isSale = row.isSale;
      this.addOrEditGroupForm.isNextMonth = row.isNextMonth;
      this.addOrEditGroupForm.supplierType = row.supplierType;
      this.addOrEditGroupForm.remark = row.remark;
      this.addOrEditGroupForm.poolName = row.poolName;
      this.addOrEditGroupForm.priceData = row.priceData;
      this.currentId = row.id;
      this.addOrEditGroupForm.isDown = row.isDown;
      this.addOrEditGroupForm.isMiao = row.isMiao;
      this.addOrEditGroupForm.miaoPrice = row.miaoPrice;
      this.addOrEditGroupForm.stopDay = row.stopDay;
    },
    addOrEidtGroupHandle() {
      this.$refs.addOrEditGroupForm.validate((valid) => {
        if (valid) {
          var data = this.addOrEditGroupForm;
          if (this.addFlag == true) {
            addPkgGroup(data).then((res) => callback(res));
          } else {
            data.id = this.currentId;
            updatePkgGroup(data).then((res) => callback(res));
          }
        }
        var _this = this;
        function callback(res) {
          if (res.data.code == 200) {
            _this.getPkgGroupListPageHandle();
            _this.addGroupVisibale = false;
          } else {
            _this.$message.error(res.data.message);
          }
        }
      });
    },
    changeStateHandle(id) {
      var data = {
        id,
      };
      changePkgGroupState(data).then((res) => {
        if (res.data.code == 200) {
          this.$message.success(res.data.message);
          this.getPkgGroupListPageHandle();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    handleSizeChange(val) {
      this.tbpg.pageSize = val;
      this.getPkgGroupListPageHandle();
    },
    handleCurrentChange(val) {
      this.tbpg.currentPage = val;
      this.getPkgGroupListPageHandle();
    },
  },
  created() {
    this.getPkgGroupListPageHandle();
    common.getPkgTypeOptionCom(this, "pkgTypeOption");
    common.getSupplierOptionCom(this, "supplierOption");
    common.getSupplierLimitOptionCom(this, 'branchSupplierOption')
    getPkgIsMonthOption().then((res) => {
      if (res.data.code == 200) {
        this.isMonthOption = res.data.data;
      } else {
        this.$message.error(res.data.message);
      }
    });
  },
};
</script>
<style></style>
